import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { LatLngLiteral } from '@agm/core';
import { BAGCILAR_GEOPATHS } from '../../_models/bagcilar';

@IonicPage()
@Component({
  selector: 'page-location',
  templateUrl: 'location.html',
})
export class LocationPage {
  locationName: string;
  public zoom: number = 16;
  latitude: number;
  longitude: number;
  currentLatitude: number;
  currentLongitude: number;
  iconUrl: String;
  adres: String;
  paths: Array<LatLngLiteral> = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController) {
    this.latitude = +this.navParams.get('latitude');
    this.longitude = +this.navParams.get('longitude');
    this.locationName = this.navParams.get('locationName');
    this.adres = this.navParams.get('adres');
    this.iconUrl = this.navParams.get('iconUrl');
    this.currentLatitude = this.navParams.get('currentLatitude');
    this.currentLongitude = this.navParams.get('currentLongitude');
    this.paths =  BAGCILAR_GEOPATHS;
  }

  ngOnInit() {

  }

  onAbort() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/location/location.ts